import React, { PureComponent } from 'react';

import { Button, Tooltip } from '..';

import styles from './styles';

export default class InputField extends PureComponent {
  inputRef = null;

  focusInput = (callback) => () => {
    console.log('button clicked');
    if (this.inputRef) {
      this.inputRef.focus();
      this.inputRef.select();
    }

    if (callback) {
      callback();
    }
  };

  renderLabel(label, hint, labelClass) {

    if (!label) {
      return null;
    }
    let tooltip = '';
    if (hint) {
      tooltip = (
        <Tooltip hint={hint} />
      );
    }

    return (
      <div className={ `${styles.inputFieldLabel} ${labelClass || ''}` }>
        { label }
        { tooltip }
      </div>
    );
  }

  renderButton(buttonText, handleSubmit) {

    if (!buttonText) {
      return null;
    }

    return (
      <Button
        className="accent-button"
        onClick={ this.focusInput(handleSubmit) }
      >
        {buttonText}
      </Button>
    );
  }

  render() {
    const { buttonText, className, labelClass, focusOnClick, handleSubmit, label, hint, ...restProps } = this.props;

    return (
      <label
        className={ `${styles.inputFieldContainer} ${className || ''}` }
        onClick={ focusOnClick ? this.focusInput() : null }
      >
        { this.renderLabel(label, hint, labelClass) }
        <div className={ styles.inputFieldFakeInput }>
          <input
            { ...restProps }
            className={ styles.inputFieldInput }
            ref={ (elem) => {
              this.inputRef = elem;
            } }
            onSubmit={ handleSubmit }
          />
          { this.renderButton(buttonText, handleSubmit) }
        </div>
      </label>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InputField/index.jsx